var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepIndicator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8695_43590)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7064 7.29279C18.8939 7.48031 18.9992 7.73462 18.9992 7.99979C18.9992 8.26495 18.8939 8.51926 18.7064 8.70679L10.7064 16.7068C10.5189 16.8943 10.2646 16.9996 9.99943 16.9996C9.73427 16.9996 9.47996 16.8943 9.29243 16.7068L5.29243 12.7068C5.11027 12.5182 5.00948 12.2656 5.01176 12.0034C5.01403 11.7412 5.1192 11.4904 5.30461 11.305C5.49002 11.1196 5.74083 11.0144 6.00303 11.0121C6.26523 11.0098 6.51783 11.1106 6.70643 11.2928L9.99943 14.5858L17.2924 7.29279C17.48 7.10532 17.7343 7 17.9994 7C18.2646 7 18.5189 7.10532 18.7064 7.29279Z",
    fill: "#00A9E7"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "#00A9E7",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8695_43590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIndicator);
export default __webpack_public_path__ + "static/media/Step_indicator.a2a09e7789659ac1476874dd367e891a.svg";
export { ForwardRef as ReactComponent };